//popup modal for viewing an item
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/esm/Button";
import style from "./ViewItemModal.module.scss"

/**
 * Modal component for editing a product.
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.show - Controls the visibility of the modal
 * @param {Function} props.onHide - Callback to close the modal
 * @param {Object} props.item - The product object to be edited
 * @param {string} props.item.name - Name of the product
 * @param {number} props.item.price - Price of the product
 * @returns {JSX.Element} A modal for editing a product's details
 *
 * @example
 * <EditProductModal
 *   show={true}
 *   onHide={() => setShow(false)}
 *   item={{ name: "Burger", price: 100 }}
 * />
 * 
 * @author Susovan
 */
function EditProductModal({show, onHide, item}) {
  return (
    <Modal
    show={show}
    onHide={onHide}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        View Product
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className={`px-5 ${style.modalScrollableBody}`}>
      <div className="row">
        <div className="col-md-7 d-flex flex-column">
          <div className="mb-3">
            <label htmlFor="productName" className="form-label">Product Name</label>
            <input disabled value={item.name || item.prodName} type="text" className="form-control" id="productName" placeholder="Product Name" />
          </div>

          <div className='d-flex gap-3'>
          <div className="mb-3">
        <label htmlFor="productPrice" className="form-label">Price</label>
        <input disabled value={item.price || item.prodPrice} type="number" className="form-control" id="productPrice" placeholder="Price" />
      </div>

      <div className="mb-3">
        <label htmlFor="productImage" className="form-label">Image Link</label>
        <input disabled value={item.imageUrl || item.img} type="text" className="form-control" id="productImage" placeholder="Image URL" />
      </div>
      </div>

      <div className='d-flex gap-3'>
      <div className="mb-3">
        <label htmlFor="productCategory" className="form-label">Category</label>
        <input disabled value={item.category?.name || item.category_id?.name || item.category || item.prodCategoryName || ''} type="text" className='form-control' />
      </div>

       <div className='mb-3'>
        <label htmlFor="" className='form-label'>Stock Quantity</label>
        <input
          value={item.stockQuantity || item.quantity}
          disabled
          type="number"
          className="form-control"
          id="productQuantity"
          placeholder="Add Quantity"
        />
      </div>
      </div>
      
      <div className="mb-3">
        <label htmlFor="productType" className="form-label">Type</label>
        <input disabled value={item.veg ? "Vegetarian" : "Non-Vegetarian"} type="text" className="form-control" id="productType" />
      </div>
      
          <div className="mb-3">
            <label htmlFor="productDescription" className="form-label">Description</label>
            <textarea disabled value={item.description || ''} className="form-control" id="productDescription" rows="3"></textarea>
          </div>
        </div>
        <div className="col-md-5 d-flex justify-content-center pt-4 align-items-center">
          <div 
            className={`${style.imageContainerDiv} border rounded d-flex justify-content-center align-items-center`}
          >
            <img style={{objectFit:"cover"}} height={140} src={item.imageUrl || item.img || "https://via.placeholder.com/140"} alt="" />
          </div>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onHide}>Close</Button>
    </Modal.Footer>
  </Modal>
  )
}
export default EditProductModal